<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid }">
    <b-modal :id="id" title="Tạo khách hàng mới" ok-title="Xác nhận" cancel-title="Đóng" size="sm">
      <template #modal-header>
        <h4>
          <i class="fa fa-pen"/>
          Sửa thông tin
        </h4>
      </template>
      <template #default>
        <b-form-group label="Tên khách hàng">
          <ValidationProvider rules="required" v-slot="{ errors }" name="fullname">
            <b-form-input type="text" v-model="fullname"></b-form-input>
            <span class="text-warning">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
        <b-form-group label="Trạng thái" label-md="3">
          <b-form-radio inline name="customRadio2" v-model="status" value="1">Hoạt động</b-form-radio>
          <b-form-radio inline name="customRadio2" v-model="status" value="0">Khóa</b-form-radio>
        </b-form-group>
        <span class="text-danger">{{serverError}}</span>
      </template>
      <template #modal-footer>
        <b-button variant="primary" @click="handleSubmit(onSubmit)">Xác nhận</b-button>
        <b-button variant="default" @click="$bvModal.hide(id);">Đóng</b-button>
      </template>
    </b-modal>
  </ValidationObserver>
</template>
<script>
import { localize } from 'vee-validate'
import api from '../../../store/api'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CustomerEditorModal',
  data () {
    return {
      fullname: '',
      status: null,
      customer_id: null
    }
  },
  watch: {
    editData: function (newVal, oldVal) {
      this.fullname = newVal.customer_name
      this.status = newVal.customer_status
      this.customer_id = newVal.customer_id
    }
  },
  props: {
    id: String,
    editData: Object
  },
  created () {
    localize('en', {
      fields: {
        'fullname': { required: 'Vui lòng nhập tên' }
      }
    })
  },
  computed: {
    ...mapGetters({
      'serverError': 'Setting/serverErrorsState'
    })
  },
  methods: {
    resetForm () {
      this.fullname = ''
      this.status = null
      this.customer_id = null
    },
    onSubmit () {
      api.customer.edit({
        name: this.fullname,
        status: this.status,
        id: this.customer_id
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Cập nhật thành công'
        })
        this.$bvModal.hide(this.id)

        this.resetForm()
        this.listCustomer()
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    mySelectEvent (event) {
    },
    ...mapActions({
      'listCustomer': 'Customer/loadList'
    })
  }
}
</script>
